import { style, styleVariants } from '@vanilla-extract/css';

export const wrapper = style({});

export const signupElement = style({
  borderRadius: 'var(--border-radius)',
  '@media': {
    'only screen and (--mobile)': {
      borderRadius: 'var(--mobile-border-radius)',
    },
  },
});

// Must switch at the same breakpoint as the button's --mobile-button-width, or a row
// layout gets a 100% wide button that squeezes the input.
export const orientation = styleVariants({
  horizontal: { flexDirection: 'row' },
  vertical: { flexDirection: 'column' },
});

export const mobileOrientation = styleVariants({
  horizontal: { '@media': { 'only screen and (--mobile)': { flexDirection: 'row' } } },
  vertical: { '@media': { 'only screen and (--mobile)': { flexDirection: 'column' } } },
});

export const input = style({
  border: 'none',
  outline: 'none',
  // tailwind adds input[type=email] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-background-color) !important',
  fontFamily: 'var(--input-font-family)',
  fontWeight: 'var(--input-font-weight)',
  fontSize: 'var(--input-font-size)',
  '::placeholder': {
    color: 'var(--placeholder-color)',
    fontFamily: 'var(--input-font-family)',
    fontWeight: 'var(--input-font-weight)',
    fontSize: 'var(--input-font-size)',
  },
  ':focus': {
    fontSize: 'var(--input-font-size) !important',
  },
  '@media': {
    'only screen and (--mobile)': {
      fontSize: 'var(--mobile-input-font-size)',
      ':focus': {
        fontSize: 'var(--mobile-input-font-size) !important',
      },
      '::placeholder': {
        fontSize: 'var(--mobile-input-font-size)',
      },
    },
  },
});

export const inputLabelStyle = style({
  display: 'block',
  fontSize: '1rem',
  fontWeight: '500',
  lineHeight: '1.5rem',
  color: 'var(--input-label-color)',
  fontFamily: 'var(--input-font-family)',
  padding: '0px',
  cursor: 'pointer',
});

export const labelStyle = style({
  display: 'block',
  fontSize: '1rem',
  fontWeight: '500',
  lineHeight: '1.5rem',
  color: 'var(--input-text-color)',
  fontFamily: 'var(--input-font-family)',
  padding: '0px',
  cursor: 'pointer',
});

export const checkboxStyle = style({
  all: 'unset',
  width: '16px',
  height: '16px',
  borderColor: 'var(--input-border-color)',
  borderWidth: 'var(--input-border-width)',
  borderStyle: 'solid',
  borderRadius: 'var(--input-checkbox-radius)',
  display: 'inline-block',
  cursor: 'pointer',
  position: 'relative',
  backgroundColor: 'var(--input-radio-checkbox-background-color)',
  margin: 0,
  padding: 0,
  WebkitTapHighlightColor: 'transparent',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  boxSizing: 'border-box',
  selectors: {
    '&:checked': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '45%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(45deg)',
      width: '4px',
      height: '8px',
      borderRight: '2px solid var(--input-radio-checkbox-background-color)',
      borderBottom: '2px solid var(--input-radio-checkbox-background-color)',
      pointerEvents: 'none',
    },
    '&:hover:not(:checked)': {
      borderColor: 'var(--input-radio-checkbox-accent-color)',
    },
    '&:focus, &:focus-visible, &:active, &:-moz-focusring, &::-moz-focus-inner': {
      outline: 'none !important',
      boxShadow: 'none !important',
      border: 'inherit !important',
    },
    '&:checked:focus, &:checked:active, &:checked:hover, &:checked:focus-visible': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:not(:checked)': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
});

export const radioStyle = style({
  all: 'unset',
  width: '16px',
  height: '16px',
  borderColor: 'var(--input-border-color)',
  borderWidth: 'var(--input-border-width)',
  borderStyle: 'solid',
  display: 'inline-block',
  borderRadius: '50%',
  cursor: 'pointer',
  position: 'relative',
  backgroundColor: 'var(--input-radio-checkbox-background-color)',
  margin: 0,
  padding: 0,
  WebkitTapHighlightColor: 'transparent',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  selectors: {
    '&:checked': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'var(--input-radio-checkbox-background-color)',
      pointerEvents: 'none',
    },
    '&:hover:not(:checked)': {
      borderColor: 'var(--input-radio-checkbox-accent-color)',
    },
    '&:focus, &:focus-visible, &:active, &:-moz-focusring, &::-moz-focus-inner': {
      outline: 'none !important',
      boxShadow: 'none !important',
      border: 'inherit !important',
    },
    '&:checked:focus, &:checked:active, &:checked:hover, &:checked:focus-visible': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
  },
});

export const button = style({
  width: 'var(--button-width, auto)',
  fontFamily: 'var(--button-font-family)',
  fontWeight: 'var(--button-font-weight)',
  fontSize: 'var(--button-font-size)',
  borderRadius: 'var(--button-border-radius)',
  backgroundColor: 'var(--button-background-color)',
  color: 'var(--button-text-color)',
  borderColor: 'var(--button-border-color)',
  borderWidth: 'var(--button-border-width)',
  borderStyle: 'var(--button-border-style)',
  pointerEvents: 'auto',
  selectors: {
    '&:hover': {
      backgroundColor: 'var(--button-hover-background-color, var(--button-background-color))',
      color: 'var(--button-hover-text-color, var(--button-text-color))',
      borderColor: 'var(--button-hover-border-color, var(--button-border-color))',
      borderStyle: 'var(--button-hover-border-style, var(--button-border-style))',
      borderWidth: 'var(--button-hover-border-width, var(--button-border-width))',
      borderRadius: 'var(--button-hover-border-radius, var(--button-border-radius))',
    },
  },
  '@media': {
    'only screen and (--mobile)': {
      width: 'var(--mobile-button-width, auto)',
      fontSize: 'var(--mobile-button-font-size)',
      borderRadius: 'var(--mobile-button-border-radius)',
      selectors: {
        '&:hover': {
          borderRadius: 'var(--button-hover-border-radius, var(--mobile-button-border-radius))',
        },
      },
    },
  },
});

export const buttonIcon = style({
  color: 'var(--button-icon-color) !important',
  selectors: {
    [`${button}:hover &`]: {
      color: 'var(--button-hover-icon-color, var(--button-icon-color)) !important',
    },
  },
});

export const inputIcon = style({
  color: 'var(--input-icon-color) !important',
});
